<app-validate-courier *ngIf="showValidateCourier"
                      (shipments)="onShipments($event)"></app-validate-courier>
<app-shipment-scanning *ngIf="showShipments"
                       [shipments]="shipments"
                       (onCloseTrip)="onClosingTrip($event)">

</app-shipment-scanning>
  
